import { render, staticRenderFns } from "./AppCookiePolicyManager.vue?vue&type=template&id=177b1c72&scoped=true&"
import script from "./AppCookiePolicyManager.vue?vue&type=script&lang=js&"
export * from "./AppCookiePolicyManager.vue?vue&type=script&lang=js&"
import style0 from "./AppCookiePolicyManager.vue?vue&type=style&index=0&id=177b1c72&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177b1c72",
  null
  
)

export default component.exports